import Reveal from "@/components/reveal";

const sections = [
  {
    title: "What we collect",
    body: "When you contact NicheBytes, we collect the details you choose to share — typically your name, email address, company and the content of your message. If you share your CV, we also process the information it contains.",
  },
  {
    title: "How we use it",
    body: "We use your details only to respond to your enquiry, discuss relevant hiring or career opportunities, and provide the recruitment services you ask for. We never sell your data or share it with third parties for marketing.",
  },
  {
    title: "How long we keep it",
    body: "Enquiry details are kept only as long as needed to handle your request and any resulting working relationship. You can ask us to delete your information at any time.",
  },
  {
    title: "Your rights",
    body: "Under the GDPR you have the right to access, correct or delete your personal data, and to object to or restrict its processing. To exercise any of these rights, email sarithajain@nichebytes.nl.",
  },
];

const Privacy = () => (
  <main data-testid="privacy-page">
    <section className="bg-[#0B132B]">
      <div className="container-nb pt-32 pb-16 md:pt-40 md:pb-20">
        <Reveal>
          <p className="eyebrow mb-6">Legal</p>
          <h1 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight leading-[1.12] text-[#F8FAFC]">
            Privacy Policy.
          </h1>
          <p className="mt-5 text-base md:text-lg text-[#94A3B8] leading-relaxed max-w-xl">
            NicheBytes is a boutique recruitment firm based in Utrecht, Netherlands. We handle your
            personal data carefully, transparently and only for the purpose you shared it.
          </p>
        </Reveal>
      </div>
    </section>

    <section className="bg-[#FAF9F5]">
      <div className="container-nb py-16 md:py-24">
        <div className="max-w-3xl divide-y divide-[#E6E2D8]">
          {sections.map((s) => (
            <Reveal key={s.title}>
              <div className="py-8">
                <h2 className="font-display text-xl font-semibold text-[#0F172A] mb-3">{s.title}</h2>
                <p className="text-sm md:text-base text-[#475569] leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
          <Reveal>
            <div className="py-8" id="cookies" data-testid="cookies-section">
              <h2 className="font-display text-xl font-semibold text-[#0F172A] mb-3">Cookie Preferences</h2>
              <p className="text-sm md:text-base text-[#475569] leading-relaxed">
                This website uses only essential cookies and privacy-respecting, anonymised product
                analytics to understand how the site is used. No advertising or cross-site tracking
                cookies are set, so there is nothing to opt out of — you're already on the minimal setting.
              </p>
            </div>
          </Reveal>
          <Reveal>
            <div className="py-8">
              <h2 className="font-display text-xl font-semibold text-[#0F172A] mb-3">Contact</h2>
              <p className="text-sm md:text-base text-[#475569] leading-relaxed">
                Questions about this policy or your data? Email{" "}
                <a href="mailto:sarithajain@nichebytes.nl" className="text-[#FF5E1A] underline underline-offset-2">
                  sarithajain@nichebytes.nl
                </a>
                . NicheBytes · Utrecht, Netherlands.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  </main>
);

export default Privacy;
